// noinspection TypeScriptPreferShortImport,ES6PreferShortImport
import { GameData } from '../../data';
import { VraiFauxAnswer, VraiFauxData, VraiFauxQuestion } from '../../games-data/vrai-faux';
import { ContentType } from '../../../models';
import { GameLevel } from '../../game-config';

interface OldVraiFauxQuestion {
  answers: VraiFauxAnswer[];
  content: {
    type: 'text';
    value: string;
  };
  difficulty: 1 | 2 | 3;
  explanation: {
    type: 'text';
    value: string;
  };
}
export function vraiFauxMigrator(game: GameData<any>): GameData<VraiFauxData> {
  return { ...game, game: migrateVraiFauxData(game.game) };
}

export function migrateVraiFauxData(game: GameData<VraiFauxData>): VraiFauxData {
  if (!game.game || !game.game.questions || !game.game.questions.length) {
    return {
      questions: [],
      configuration: {
        labelChange: 0,
        labelLeft: '',
        labelRight: '',
      },
    };
  }
  const questions: VraiFauxQuestion[] = (<OldVraiFauxQuestion[]>(<unknown>game.game.questions)).map((q, i) => {
    const explanations = [];
    if (q.explanation && q.explanation.value) {
      explanations.push({ content: q.explanation.value, type: <ContentType>q.explanation.type });
    }
    return {
      contents: [{ content: q.content.value, type: <ContentType>q.content.type }],
      explanations,
      answers: q.answers,
      difficulty: getDifficulty(q.difficulty),
      index: i,
    };
  });
  return {
    questions,
    configuration: {
      labelChange: 0,
      labelLeft: '',
      labelRight: '',
    },
  };
}

function getDifficulty(nDiff: 1 | 2 | 3): GameLevel {
  switch (nDiff) {
    case 1:
      return GameLevel.EASY;
    case 2:
      return GameLevel.MEDIUM;
    case 3:
      return GameLevel.HARD;
  }
}
